import { Box, Typography } from '@mui/material';

function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <Box className="footer">
      <Typography variant="body2">
        Contact: ovechtom@uwaterloo.ca
      </Typography>
      <Typography variant="body2">
        &copy; {currentYear} Olga Vechtomova
      </Typography>
    </Box>
  );
}

export default Footer;
